import React, {useRef} from 'react';
import Article from './Article';
import {withRouter, RouteComponentProps} from 'react-router';
import {RedirectWithParams} from 'epic-diesel-common';
import {LoadIndicator} from '../../components';
import {NewsState} from '../../reducers/news.reducer';
import {withPageLayout, WithPageLayoutProps} from '../../hocs';
import {useSelector} from 'react-redux';
import {RootState} from '../..';
import {selectNews} from '../../selectors';

export type ArticleViewProps = WithPageLayoutProps &
    RouteComponentProps<{locale?: string; slug?: string}>;

const ArticleView: React.FC<ArticleViewProps> = props => {
    const articleRef = useRef();
    const newsState = useSelector<RootState, NewsState>(selectNews);
    const {loading} = newsState || {};
    const {enableNews} = props.configState || {};

    if (!enableNews) {
        return <RedirectWithParams to="overview" />;
    }

    return (
        <LoadIndicator isLoading={loading} messages={props.messages}>
            <Article newsState={newsState} {...props} ref={articleRef} />
        </LoadIndicator>
    );
};

export default withRouter(withPageLayout(ArticleView));
